// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import React from 'react';
import WarningsIcon from '@styles/webdesktop/Icons/warning.svg';
const ICON_MAP = {
    none: null,
    warning: React.createElement(WarningsIcon, null)
};
export function NotificationMessage({ type, text }) {
    const icon = ICON_MAP[type];
    return (React.createElement("div", { className: `notification-message ${type}` },
        React.createElement("div", { className: "notification-message-icon" }, icon),
        React.createElement("div", { className: "notification-message-text" }, text)));
}
